import { Link } from 'react-router-dom'
import { useForge } from '../data/useForge'
import { useI18n } from '../i18n/useI18n'
import { Icon } from '../components/Icon'
import { Layout } from '../components/Layout'

export default function Workflows() {
  const { t, lang } = useI18n()
  const { registry, selectWorkflow, selectedWorkflow } = useForge()

  const workflows = registry?.workflows ?? []

  return (
    <Layout>
      <div className="px-4 py-12 md:px-margin-desktop">
        <header className="mb-12">
          <h1 className="font-display-lg text-display-lg text-on-surface">{t.workflows.title}</h1>
          <p className="mt-4 max-w-2xl font-body-lg text-body-lg text-on-surface-variant">{t.workflows.subtitle}</p>
        </header>

        <div className="grid grid-cols-1 gap-gutter xl:grid-cols-2">
          {workflows.map((wf) => {
            const isSelected = selectedWorkflow === wf.id
            return (
              <article
                key={wf.id}
                className={`tactile-card flex flex-col overflow-hidden rounded-xl border bg-surface-container-lowest ${
                  isSelected ? 'border-primary ring-1 ring-primary' : 'border-surface-container-highest'
                }`}
              >
                <div className="h-24 w-full border-b border-surface-container-highest bg-surface-container-high">
                  <div className="flex h-full items-center justify-center">
                    <Icon name={wf.icon} size={40} className="text-primary/60" />
                  </div>
                </div>

                <div className="flex flex-1 flex-col p-card-padding">
                  <div className="mb-4 flex items-start justify-between">
                    <h2 className="flex items-center gap-2 font-headline-md text-headline-md text-on-surface">
                      <Icon name={wf.icon} size={22} className="text-primary" />
                      {lang === 'zh' ? wf.nameZh : wf.name}
                    </h2>
                    <span className="rounded bg-surface-container-highest px-2 py-1 font-label-sm text-label-sm text-on-surface-variant">
                      {t.workflows.estSteps}: {wf.estSteps}
                    </span>
                  </div>

                  <p className="mb-6 flex-1 font-body-md text-body-md text-on-surface-variant">
                    {lang === 'zh' ? wf.descriptionZh : wf.description}
                  </p>

                  <div className="mb-6 border-t border-surface-container-highest pt-4">
                    <h3 className="mb-3 font-label-sm text-label-sm font-semibold uppercase tracking-widest text-on-surface">
                      {t.workflows.recommendedSkills}
                    </h3>
                    <ul className="space-y-2">
                      {wf.skillIds.slice(0, 3).map((skillId) => {
                        const skill = registry?.skills.find((s) => s.id === skillId)
                        return (
                          <li
                            key={skillId}
                            className="flex items-center gap-2 font-body-md text-body-md text-on-surface-variant"
                          >
                            <Icon name="check_circle" size={16} className="text-outline" />
                            {skill ? (lang === 'zh' ? skill.nameZh : skill.name) : skillId}
                          </li>
                        )
                      })}
                    </ul>
                  </div>

                  <div className="flex gap-3">
                    <button
                      type="button"
                      onClick={() => selectWorkflow(wf.id)}
                      className={`flex flex-1 items-center justify-center gap-2 rounded-lg py-3 font-label-sm text-label-sm font-bold shadow-sm transition-all active:scale-[0.98] ${
                        isSelected
                          ? 'border border-primary bg-primary text-on-primary'
                          : 'bg-primary text-on-primary hover:bg-surface-tint'
                      }`}
                    >
                      <Icon name={isSelected ? 'check' : 'add'} size={18} />
                      {isSelected ? t.workflows.selected : t.workflows.selectWorkflow}
                    </button>
                    <Link
                      to={`/workflows/${wf.id}`}
                      className="flex items-center justify-center rounded-lg border border-outline px-4 py-3 font-label-sm text-label-sm text-on-surface transition-colors hover:bg-surface-container-low"
                    >
                      {t.workflows.details}
                    </Link>
                  </div>
                </div>
              </article>
            )
          })}
        </div>
      </div>
    </Layout>
  )
}
